import { gql } from '@apollo/client';
const NOTIFICATION = gql `
  fragment NotificationNodeFields on NotificationNode {
    id
    createdDate
    message
    status
    isRead
    conversation {
      id
      title
      pageUrl
      type
      # ...other fields
    }
    author {
      id
      username
      avatar
    }
    user {
      id
      username
      avatar
    }
  }
`;
export default NOTIFICATION;
